import { ContextSelectedOptions } from "../../../../../context-selector/src/ContextDropdown";
import { TemporalContext } from "../../../components/temporalContextSelector/data/temporalContextOptions";

export const topTenQueryKeys = {
  all: ["topTen"] as const,
  purchase: () => [...topTenQueryKeys.all, "purchase"] as const,
  purchaseData: (
    contextOptions: ContextSelectedOptions,
    temporalOptions: TemporalContext
  ) =>
    [
      ...topTenQueryKeys.purchase(),
      { contextOptions, temporalOptions }
    ] as const,
  sales: () => [...topTenQueryKeys.all, "sales"] as const,
  salesData: (
    contextOptions: ContextSelectedOptions,
    temporalOptions: TemporalContext
  ) =>
    [...topTenQueryKeys.sales(), { contextOptions, temporalOptions }] as const
};

export const inSeasonReviewQueryKeys = {
  all: ["inSeasonReview"] as const,
  data: (options: Record<string, unknown>) =>
    [...inSeasonReviewQueryKeys.all, { options }] as const
} as const;

export const trendLineQueryKeys = {
  all: ["trendLine"] as const,
  data: (options: Record<string, unknown>) =>
    [...trendLineQueryKeys.all, { options }] as const
} as const;

export const rrpKpisQueryKeys = {
  all: ["rrpKpis"] as const,
  data: (options: Record<string, unknown>) =>
    [...rrpKpisQueryKeys.all, { options }] as const
} as const;

export const categoryAggregatesQueryKeys = {
  all: ["inSeasonReview", "aggregates"] as const,
  data: (
    level: "category" | "subcategory",
    selectedCategory: string | undefined,
    options: Record<string, unknown>
  ) =>
    [
      ...categoryAggregatesQueryKeys.all,
      level,
      selectedCategory,
      options
    ] as const
} as const;

export const priceDilutionQueryKeys = {
  all: ["priceDilution"] as const,
  data: (options: Record<string, unknown>) =>
    [...priceDilutionQueryKeys.all, { options }] as const
} as const;

export const colourChartQueryKeys = {
  all: ["colourChart"] as const,
  data: (options: Record<string, unknown>) =>
    [...colourChartQueryKeys.all, { options }] as const
} as const;
